import { buildClient } from '../utils/url';
var calculationsService = {
    baseUrl: {
        SERVICE: 'calculations',
        CALCULATIONS: 'calculations',
        QUANTITIES_VOLUMES: 'quantities/volumes',
        ORGANIZATION_EMISSIONS: 'organization/emissions',
        ORGANIZATION_CONSUMPTIONS: 'organization/consumptions',
        PRODUCT_EMISSIONS: 'product/emissions',
        PRODUCT_CONSUMPTIONS: 'product/consumptions',
        PREVIEW: 'preview',
        METHODOLOGY_CHANGELOG: 'methodology-changelog',
    },
    preview: {
        CALCULATE_LOGS: '/logs',
    },
    calculations: {
        CALCULATE_LOGS: '/logs',
        GET_FACTOR_VALUE: '/factor-value',
        GET_CONSUMPTIONS: '/consumptions',
        GET_ORGANIZATION_EMISSIONS_SUM: '/organization-sum',
        GET_PRODUCT_EMISSIONS_SUM: '/product-sum',
        GET_EMISSIONS_GROUP_BY: '/organization-sum-group-by',
    },
    organizationEmissions: {
        GET_ONE: '/:id',
        GET_MANY: '/',
        CREATE: '/',
        DELETE_ONE: '/:id',
        UPDATE_ONE: '/:id',
        GET_WITH_FACTORS: '/factors',
        GET_EMISSIONS_SUM: '/sum',
        GET_EMISSIONS_GROUP_BY: '/sum-group-by',
    },
    productEmissions: {
        GET_ONE: '/:id',
        GET_MANY: '/',
        CREATE: '/',
        DELETE_ONE: '/:id',
        UPDATE_ONE: '/:id',
        GET_WITH_FACTORS: '/factors',
        GET_EMISSIONS_SUM: '/sum',
        CARBON_VALUE: '/carbonValue',
    },
    quantitiesVolumes: {
        GET_ONE: '/:id',
        GET_MANY: '/',
        CREATE: '/',
        DELETE_BY_QUANTITY_ID: '/quantity/:id',
        DELETE_ONE: '/:id',
        UPDATE_ONE: '/:id',
        UPDATE_CALCULATIONS: '/calculations',
    },
    methodologyChangelog: {
        GET_MANY: '/',
        GET_CHANGELOG_LOGS: '/logs',
        GET_CHANGELOG_PRODUCTS: '/products',
        RECALCULATE_CHANGELOGS: '/recalculate',
        PROCESS_NEW_CHANGELOG: '/process/:id',
    },
};
var calculationsServiceClient = {
    calculations: buildClient(calculationsService.baseUrl.CALCULATIONS, calculationsService.calculations),
    preview: buildClient(calculationsService.baseUrl.PREVIEW, calculationsService.preview),
    quantitiesVolumes: buildClient(calculationsService.baseUrl.QUANTITIES_VOLUMES, calculationsService.quantitiesVolumes),
    organizationEmissions: buildClient(calculationsService.baseUrl.ORGANIZATION_EMISSIONS, calculationsService.organizationEmissions),
    productEmissions: buildClient(calculationsService.baseUrl.PRODUCT_EMISSIONS, calculationsService.productEmissions),
    methodologyChangelog: buildClient(calculationsService.baseUrl.METHODOLOGY_CHANGELOG, calculationsService.methodologyChangelog),
};
var calculationsApiGatewayClient = {
    calculations: buildClient("".concat(calculationsService.baseUrl.SERVICE, "/").concat(calculationsService.baseUrl.CALCULATIONS), calculationsService.calculations),
    preview: buildClient("".concat(calculationsService.baseUrl.SERVICE, "/").concat(calculationsService.baseUrl.PREVIEW), calculationsService.preview),
    quantitiesVolumes: buildClient("".concat(calculationsService.baseUrl.SERVICE, "/").concat(calculationsService.baseUrl.QUANTITIES_VOLUMES), calculationsService.quantitiesVolumes),
    organizationEmissions: buildClient("".concat(calculationsService.baseUrl.SERVICE, "/").concat(calculationsService.baseUrl.ORGANIZATION_EMISSIONS), calculationsService.organizationEmissions),
    productEmissions: buildClient("".concat(calculationsService.baseUrl.SERVICE, "/").concat(calculationsService.baseUrl.PRODUCT_EMISSIONS), calculationsService.productEmissions),
    methodologyChangelog: buildClient("".concat(calculationsService.baseUrl.SERVICE, "/").concat(calculationsService.baseUrl.METHODOLOGY_CHANGELOG), calculationsService.methodologyChangelog),
};
export { calculationsService, calculationsServiceClient, calculationsApiGatewayClient };
//# sourceMappingURL=calculations-service.js.map